var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 100,
    viewBox: "0 0 122 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3007 39.2001C46.5174 39.2012 45.7612 38.9142 45.1759 38.3937L28.9839 24.0001L46.0751 8.8065C46.7121 8.26152 47.5376 7.98831 48.374 8.04562C49.2104 8.10293 49.9909 8.48618 50.5477 9.11297C51.1045 9.73975 51.393 10.56 51.3513 11.3973C51.3096 12.2346 50.941 13.0221 50.3247 13.5905L38.6159 24.0001L49.4255 33.6065C49.9111 34.0374 50.2542 34.6058 50.4092 35.2363C50.5641 35.8668 50.5236 36.5295 50.2931 37.1364C50.0625 37.7434 49.6528 38.2658 49.1184 38.6344C48.5839 39.003 47.9499 39.2003 47.3007 39.2001V39.2001ZM75.9247 39.1937L93.0159 24.0001L76.8239 9.6065C76.1895 9.04297 75.3572 8.75454 74.5101 8.80464C73.6631 8.85475 72.8706 9.23931 72.3071 9.8737C71.7436 10.5081 71.4551 11.3404 71.5052 12.1874C71.5553 13.0345 71.9399 13.827 72.5743 14.3905L83.3839 24.0001L71.6751 34.4065C71.0403 34.97 70.6553 35.7627 70.6049 36.61C70.5545 37.4574 70.8428 38.2901 71.4063 38.9249C71.9698 39.5597 72.7625 39.9447 73.6098 39.9951C74.4572 40.0455 75.2899 39.7572 75.9247 39.1937V39.1937ZM60.9551 43.7281L67.3551 5.3281C67.4369 4.90843 67.4338 4.47662 67.346 4.05817C67.2581 3.63971 67.0873 3.24311 66.8436 2.89178C66.5999 2.54045 66.2883 2.24152 65.9271 2.01265C65.566 1.78378 65.1626 1.62961 64.7408 1.55925C64.3191 1.48889 63.8875 1.50376 63.4716 1.60299C63.0557 1.70221 62.6639 1.88379 62.3194 2.13697C61.9748 2.39016 61.6845 2.70983 61.4656 3.0771C61.2466 3.44437 61.1035 3.8518 61.0447 4.27531L54.6447 42.6753C54.5628 43.095 54.5659 43.5268 54.6538 43.9452C54.7416 44.3637 54.9125 44.7603 55.1562 45.1116C55.3999 45.463 55.7115 45.7619 56.0727 45.9908C56.4338 46.2196 56.8372 46.3738 57.2589 46.4442C57.6807 46.5145 58.1122 46.4996 58.5281 46.4004C58.9441 46.3012 59.3358 46.1196 59.6804 45.8664C60.025 45.6132 60.3153 45.2936 60.5342 44.9263C60.7531 44.559 60.8963 44.1516 60.9551 43.7281V43.7281Z",
    fill: "url(#paint0_linear_183_25)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66 99V56.4H15.36V72.6L28.32 56.4H41.52L26.04 75.48L42.6 99H29.16L18.6 83.34L15.36 86.7V99H3.66ZM54.9258 56.4H68.0058L81.5658 99H69.6858L67.1058 90.66H55.7658L53.2458 99H41.3058L54.9258 56.4ZM65.2458 82.86L61.4658 67.86L57.5058 82.86H65.2458ZM94.9453 56.4H108.025L121.585 99H109.705L107.125 90.66H95.7853L93.2653 99H81.3253L94.9453 56.4ZM105.265 82.86L101.485 67.86L97.5253 82.86H105.265Z",
    fill: "url(#paint1_linear_183_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_25",
    x1: 29.5978,
    y1: 2.79676,
    x2: 86.9813,
    y2: 48.1815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771759,
    stopColor: "#00FFB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_183_25",
    x1: 1.16962,
    y1: 57.2534,
    x2: 53.8719,
    y2: 138.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771759,
    stopColor: "#00FFB4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    fill: "white",
    transform: "translate(29)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a252203c584f792e98f4974dd4154bf3.svg";
export { ForwardRef as ReactComponent };